'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="m14.093 10.311 8.19-9.31h-1.94L13.23 9.084 7.55 1H1l8.589 12.225L1 22.99h1.94l7.51-8.537 5.999 8.537H23zm-2.658 3.022-.87-1.217L3.64 2.429h2.981l5.588 7.817.87 1.218 7.264 10.161h-2.98z" /></svg>;
const IconSocialX = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconSocialX;